import i18n from '@/libs/i18n'
import {
  applyVisibilityClasses,
  classesToVisibility,
  VISIBILITY_DEVICES,
} from './visibility'

const visibilityTraitPlugin = editor => {
  editor.TraitManager.addType('visibility-device', {
    createInput() {
      const el = document.createElement('div')
      el.className = 'gjs-visibility-devices'

      el.innerHTML = VISIBILITY_DEVICES.map(device => `
        <button
          type="button"
          class="gjs-visibility-device is-active"
          data-device="${device.id}"
          aria-pressed="true"
          title="${i18n.t(device.i18nKey)}"
        >
          <i class="fa ${device.icon}" aria-hidden="true"></i>
          <span>${i18n.t(device.i18nKey)}</span>
        </button>
      `).join('')

      el.addEventListener('click', event => {
        const button = event.target.closest('[data-device]')
        if (!button) return

        button.classList.toggle('is-active')
        button.setAttribute('aria-pressed', button.classList.contains('is-active') ? 'true' : 'false')
        el.dispatchEvent(new Event('change', { bubbles: true }))
      })

      return el
    },

    onUpdate({ elInput, component }) {
      const visible = new Set(classesToVisibility(component.getClasses()))

      elInput.querySelectorAll('[data-device]').forEach(button => {
        const isActive = visible.has(button.dataset.device)
        button.classList.toggle('is-active', isActive)
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })
    },

    onEvent({ elInput, component }) {
      const visibleIds = [...elInput.querySelectorAll('[data-device].is-active')]
        .map(button => button.dataset.device)

      component.setClass(applyVisibilityClasses(component.getClasses(), visibleIds))
    },
  })

  const ensureVisibilityTrait = comp => {
    if (!comp) return
    if (comp.getTrait && comp.getTrait('visibility')) return

    if (comp.addTrait) {
      comp.addTrait({
        type: 'visibility-device',
        name: 'visibility',
        label: i18n.t('Visibility'),
      })
    }
  }

  editor.on('load', () => {
    const wrapper = editor.getWrapper()
    const allComponents = [wrapper, ...wrapper.find('*')]

    allComponents.forEach(ensureVisibilityTrait)
  })

  editor.on('component:add', comp => {
    ensureVisibilityTrait(comp)
  })
}

export default visibilityTraitPlugin
